import {
  clearBillingThreeDsIntent,
  readBillingThreeDsIntent,
  writeBillingThreeDsIntent,
} from '../billing/three-ds-intent'

export {
  clearBillingThreeDsIntent,
  readBillingThreeDsIntent,
  writeSubscriptionUpgradeThreeDsIntent,
} from '../billing/three-ds-intent'

export interface TeamSubscriptionThreeDsIntent {
  product: 'team_subscription'
  tradeId: number
}

/**
 * Persist the product-specific intent before leaving for the bank challenge.
 * `sessionStorage` keeps it scoped to the checkout tab and survives the
 * cross-origin 3DS round trip without leaking it into future browser sessions.
 */
export function writeTeamSubscriptionThreeDsIntent(tradeId: number): void {
  if (!Number.isInteger(tradeId) || tradeId <= 0) {
    throw new Error('Team 3DS checkout is missing a valid trade id')
  }
  writeBillingThreeDsIntent({ product: 'team_subscription', tradeId })
}

export function readTeamSubscriptionThreeDsIntent(): TeamSubscriptionThreeDsIntent | null {
  const intent = readBillingThreeDsIntent()
  return intent?.product === 'team_subscription' ? intent : null
}

export function clearTeamSubscriptionThreeDsIntent(): void {
  clearBillingThreeDsIntent()
}
